var render = function render(){var _vm=this,_c=_vm._self._c;return (true)?_c('div',{staticClass:"h-toast",class:{ 'fade-in': _vm.fadeIn, 'fade-out': _vm.fadeOut }},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }